// Uploads a picture to Cloudinary (the site's image host) and returns its
// address. Used for event pictures, pictures in descriptions and profile
// pictures.
const CLOUDINARY_CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const CLOUDINARY_UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;
const MAX_BYTES = 10 * 1024 * 1024;

export async function uploadImage(file) {
  if (!file || !String(file.type || '').startsWith('image/')) {
    throw new Error('That file isn’t a picture. Choose a photo or image.');
  }
  if (file.size > MAX_BYTES) {
    throw new Error('That picture is over 10 MB. Choose a smaller one.');
  }
  if (!CLOUDINARY_CLOUD_NAME || !CLOUDINARY_UPLOAD_PRESET) {
    throw new Error('Picture uploads aren’t set up yet.');
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);

  let data = {};
  try {
    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`,
      { method: 'POST', body: formData }
    );
    data = await response.json();
    if (!response.ok || !data.secure_url) throw new Error('upload failed');
  } catch (error) {
    throw new Error('The upload didn’t work. Check your connection and try again.');
  }
  return data.secure_url;
}
